// extracted by mini-css-extract-plugin
export var productImage = "_108-0";